import { __extends } from '../_virtual/_tslib.js';
import { expects, requestOptions, DEFAULT_HEADERS, auth, sanitizeScope } from '../utils.js';
import { BaseFlow } from './base-flow.js';

/**
 * Support assertion credentials OAuth 2.0 grant.
 *
 * @param {JSOAuth2} client
 */
var AssertionFLow = /** @class */ (function (_super) {
    __extends(AssertionFLow, _super);
    function AssertionFLow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getToken = function (assertion, provider, opts) {
            var options = Object.assign({}, _this.client.options, opts);
            expects(options, ['accessTokenUri', 'clientId', 'clientSecret']);
            return _this.client
                ._request(requestOptions({
                url: options.accessTokenUri,
                method: 'POST',
                headers: Object.assign({}, DEFAULT_HEADERS, {
                    Authorization: auth(options.clientId, options.clientSecret),
                }),
                body: {
                    scope: sanitizeScope(options.scopes),
                    assertion: assertion,
                    provider: provider,
                    grant_type: 'assertion',
                },
            }, options))
                .then(_this.client.createToken);
        };
        return _this;
    }
    return AssertionFLow;
}(BaseFlow));

export { AssertionFLow };
